// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sceau {
    padding: 20px;
}

.links {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
    /* Espacement entre les boutons */
    justify-content: center;
    /* Centrer les boutons */
}

.links button {
    width: 100px;
    /* Taille fixe pour chaque bouton */
    height: 40px;
    /* Hauteur fixe pour chaque bouton */
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 5px;
    padding: 10px;
    color: white;
    /* Couleur du texte */
    background-color: rgb(84, 71, 27);
    /* Fond marron */
    border: 1px solid #ccc;
    border-radius: 4px;
    text-align: center;
    box-sizing: border-box;
    cursor: pointer;
    /* Curseur de pointeur pour les boutons */
}

.links button:hover {
    color: red;
}`, "",{"version":3,"sources":["webpack://./src/css/Sceau.css"],"names":[],"mappings":"AAAA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,SAAS;IACT,iCAAiC;IACjC,uBAAuB;IACvB,wBAAwB;AAC5B;;AAEA;IACI,YAAY;IACZ,mCAAmC;IACnC,YAAY;IACZ,oCAAoC;IACpC,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,aAAa;IACb,YAAY;IACZ,qBAAqB;IACrB,iCAAiC;IACjC,gBAAgB;IAChB,sBAAsB;IACtB,kBAAkB;IAClB,kBAAkB;IAClB,sBAAsB;IACtB,eAAe;IACf,yCAAyC;AAC7C;;AAEA;IACI,UAAU;AACd","sourcesContent":[".sceau {\n    padding: 20px;\n}\n\n.links {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 10px;\n    /* Espacement entre les boutons */\n    justify-content: center;\n    /* Centrer les boutons */\n}\n\n.links button {\n    width: 100px;\n    /* Taille fixe pour chaque bouton */\n    height: 40px;\n    /* Hauteur fixe pour chaque bouton */\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    margin: 5px;\n    padding: 10px;\n    color: white;\n    /* Couleur du texte */\n    background-color: rgb(84, 71, 27);\n    /* Fond marron */\n    border: 1px solid #ccc;\n    border-radius: 4px;\n    text-align: center;\n    box-sizing: border-box;\n    cursor: pointer;\n    /* Curseur de pointeur pour les boutons */\n}\n\n.links button:hover {\n    color: red;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
